export default "__VITE_ASSET__DT1BZR13__"